module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_gr-8d1382947989d24873d743eaa018903e.png";